export const CUSTOM_SITES_CARDS_EXTENSION_FF = 'confluence.frontend.custom-sites.cards-extension';
